const CART_LOCK_NAME = "sculptocms:webshops:cart";
let cartFallbackQueue: Promise<void> = Promise.resolve();

/**
 * Serializes cart reads and writes. Web Locks coordinate every same-origin tab;
 * the promise queue preserves ordering within this module when Web Locks are not
 * available. Keeping GET in the same queue prevents a slow mount read from
 * resolving after and overwriting a newer mutation in the same page.
 */
export function serializeCartRequest<T>(operation: () => Promise<T>): Promise<T> {
  if (typeof navigator !== "undefined" && navigator.locks) {
    // lib.dom models the callback result synchronously, while the Web Locks
    // runtime awaits thenables. The extra `then` flattens that type/runtime seam.
    return navigator.locks
      .request(CART_LOCK_NAME, { mode: "exclusive" }, operation)
      .then((result) => result);
  }

  const result = cartFallbackQueue.then(operation, operation);
  cartFallbackQueue = result.then(
    () => undefined,
    () => undefined,
  );
  return result;
}
